<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col">
          <h1 class="text-white pt-3 px-3">สรุปข้อมูลที่สร้างพัสดุ</h1>
          <p
            class="text-white pb-0 px-3"
          >แสดงข้อมูลพัสดุทั้งหมดของสาขาที่สร้างใบนำส่งพัสดุ โดยสามารถเลือกวันที่สามารถมาแสดงผลได้</p>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row">
                <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                  <b-form-group label="ค้นหาวันที่ (วันเริ่มต้น - วันสุดท้าย)" class="mb-0" >
                    <div class="row">
                      <div class="col-12 col-md-8 col-lg-8">
                        <date-range-picker
                          class="w-100"
                          :opens="'center'"
                          @start-selection="logEvent('startSelection', $event)"
                          @finish-selection="logEvent('finishSelection', $event)"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :singleDatePicker="false"
                          :appendToBody="true"
                          :ranges="false"
                          :closeOnEsc="false"
                          :autoApply="true"
                          :locale-data="{ format: 'dd/mm/yyyy' }"
                          v-model="filters">
                        </date-range-picker>
                      </div>
                      <div class="col-12 col-md-3 col-lg-2">
                        <button class="btn btn-info btn-sm-res" v-on:click="getReportDelivery()">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                     
                    </div>
                  </b-form-group>
                  <hr class="d-md-none d-lg-none" />
                </div>
                <div class="col-12 col-md-6 col-lg-8 col-xl-6 mb-3"> 
                  <b-form-group
                    id="input-group-1"
                    label="ค้นหาข้อมูล"
                    label-for="input-1"
                    class="mb-0 col-6"
                  >
                    <b-form-input v-model="filter" id="input-1" type="text" required placeholder></b-form-input>
                  </b-form-group>   
                  <hr class="d-block d-md-none d-lg-none mb-0" />
                </div>
              </div>
            </div>
            <div id="tablePrint">
              <b-table
                ref="reportDelivery"
                show-empty
                responsive
                :items="itemFilter"
                :fields="fields"
                :busy="busy"
                class="scroll-bar-pop"
              >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                <template slot="created_at" slot-scope="row">{{ row.item.created_at.date | dateFormat }}</template>
                <template slot="manage" slot-scope="row">
                  <!-- <router-link :to="`/deliverydetail/${row.item.id}`" class="px-1">
                    <button class="btn btn-sm btn-primary">รายละเอียด</button>
                  </router-link> -->
                  <router-link :to="`/delivery/${row.item.id}`" target="_blank" class="px-1">
                    <button class="btn btn-sm btn-info">ใบนำส่งพัสดุ</button>
                  </router-link>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validatePop from "../../plugins/validatePop.js";
// import PageVisitsTable from "../Dashboard/PageVisitsTable";
import moment from "moment";
import { dateLimitRanges } from "@/plugins/datePicker.js"
const API_URL = process.env.VUE_APP_API;
export default {
  data() {
    return {
      itemDelivery: [],
      selectFilter: undefined,
      busy: true,
      userLogin: "",
      filter: '',
      minDate: null,
      maxDate: moment().format("YYYY-MM-DD"),
      filters: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      selected: [],
      checkSelect: false
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  created(){
    this.userLogin = JSON.parse(localStorage.getItem("user"))
  },
  mounted() {
    this.getReportDelivery();
  },
  methods: {
    logEvent( event , date ){
        const { minDate , maxDate } =  dateLimitRanges(event, date);
        this.minDate = minDate
        this.maxDate = maxDate
    },
    getReportDelivery() {
      this.busy = true;
      this.$http
        .post(
          API_URL + "/delivery",
          {
            start: moment(this.filters.startDate).format("YYYY-MM-DD"),
            end: moment(this.filters.endDate).format("YYYY-MM-DD"),
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.itemDelivery = res.data.data
          this.busy = false
        });
    },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    isSuperAdmin() {
      return this.userLogin.role === "superadmin";
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
  },
  computed: {
    fields(){ 
     let fields = [
        { key: "index", label: "ลำดับ", sortable: true },
        { key: "created_at", label: "วันที่สร้างรายการ", sortable: true },
        { key: "delivery_no", label: "เลขที่ใบนำส่งพัสดุ No.", sortable: true },
        { key: "manage", label: "การจัดการ" }
      ]
      return fields
    },
    itemFilter() {
      let item = this.itemDelivery.filter(item => {
        let keys = Object.keys(item);
        if(this.selectFilter === undefined &&!this.filter){
          return true
        }
        else if (this.selectFilter === undefined && this.filter){
        return Object.values(item).some((val)=>{
          return String(val).toLowerCase().includes(this.filter.toLowerCase())
         })
        }
      })
      return item;
    },
    total() {
      return this.itemFilter.reduce((total, product) => {
        return total + Number(product.price);
      }, 0);
    },
  }
};
</script>

<style></style>
 